const { ConfigService } = require("./config.service");

const configService = new ConfigService();

// Set your endpoints based on the environment
const APIURLS = {
    production: {
        api_url: process.env.REACT_APP_API_URL_PRODUCTION
    },
    test: {
        // api_url: "http://localhost:8000/api/enebid"
        api_url: process.env.REACT_APP_API_URL_TEST
    },
    development: {
        // api_url: "http://localhost:8000/api/enebid"
        api_url: process.env.REACT_APP_API_URL_DEVELOPMENT
    }
};

// Determining the environment from a .env file or any other means
const environment = configService.getEnvironment();
const { api_url } = APIURLS[environment];

module.exports = {
    api_url
}